/**
 * @file
 * Example of a custom script file.
 */

((Drupal,$, drupalSettings) => {
  Drupal.behaviors.GDSSubthemeGlobal = {
    attach: (context, settings) => {

    },
  };
})(Drupal, jQuery, drupalSettings);
